module.exports = __webpack_public_path__ + "static/media/UploadImage.2322796c.svg";